//add controls for individual forms and switch out other forms for these controls
import { formatMoney } from "../../utils/helpers";
import General from "../profile/General";
import Health from "../profile/Health";
import Insurance from "../profile/Insurance";
import Passport from "../profile/Passport";
import Church from "../profile/Church";
import Contacts from "../profile/Contacts";
import References from "../profile/References";
import Skills from "../profile/Skills";
import Education from "../profile/Education";

const SECTION_TITLES = {
  General:    'GENERAL',
  Health:     'HEALTH',
  Insurance:  'INSURANCE',
  Passport:   'PASSPORT',
  Church:     'CHURCH',
  Skills:     'SKILLS',
  Education:  'EDUCATION',
  References: 'REFERENCES',
  Contacts:   'EMERGENCY CONTACTS',
};

function SectionHeader({ title }) {
  return (
    <div className="full-row gray px-4 py-3 mb-3 mt-4 rounded">
      <h6 className="mb-0 text-uppercase fw-bold">{title}</h6>
    </div>
  );
}

function ProfileSections(props) {
  const Registration = props.Registration;
  if (!Registration) return null;

  const sections = Registration.ProfileSections || '';
  const has = (name) => sections.includes(name);

  return (
    <div className="profileSectionsForm registrationProfileSections">
      {/* Align inner profile-section rows to the Dates Attending width (px-4) */}
      <style>{`
        .registrationProfileSections .profileSectionItem .row.px-5 {
          padding-left: 1.5rem !important;
          padding-right: 1.5rem !important;
        }
        .registrationProfileSections .profileSectionItem .row.pt-5 {
          padding-top: 1rem !important;
        }
        .registrationProfileSections .profileSectionItem hr { margin: 0.5rem 1.5rem; }
      `}</style>

      <div className="full-row gray px-4 py-3 mb-4 rounded">
        <div className="row align-items-center">
          <div className="col">
            <h5 className="mb-0 text-uppercase">{Registration.RegistrationName}</h5>
          </div>
          {Registration.RegistrationCost > 0 && (
            <div className="col-auto">
              <span className="badge bg-white text-dark fs-6">
                {formatMoney(Registration.RegistrationCost)}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="profileSection">
        {has("General") && (
          <div className="profileSectionItem General">
            <SectionHeader title={SECTION_TITLES.General} />
            <General UseFormContext={true} />
          </div>
        )}
        {has("Health") && (
          <div className="profileSectionItem Health">
            <SectionHeader title={SECTION_TITLES.Health} />
            <Health UseFormContext={true} />
          </div>
        )}
        {has("Insurance") && (
          <div className="profileSectionItem Insurance">
            <SectionHeader title={SECTION_TITLES.Insurance} />
            <Insurance UseFormContext={true} />
          </div>
        )}
        {has("Passport") && (
          <div className="profileSectionItem Passport">
            <SectionHeader title={SECTION_TITLES.Passport} />
            <Passport UseFormContext={true} />
          </div>
        )}
        {has("Church") && (
          <div className="profileSectionItem Church">
            <SectionHeader title={SECTION_TITLES.Church} />
            <Church UseFormContext={true} />
          </div>
        )}
        {has("Skills") && (
          <div className="profileSectionItem Skills">
            <SectionHeader title={SECTION_TITLES.Skills} />
            <Skills UseFormContext={true} />
          </div>
        )}
        {has("Education") && (
          <div className="profileSectionItem Educations">
            <SectionHeader title={SECTION_TITLES.Education} />
            <Education UseFormContext={true} />
          </div>
        )}
        {has("References") && (
          <div className="profileSectionItem References">
            <SectionHeader title={SECTION_TITLES.References} />
            <References UseFormContext={true} />
          </div>
        )}
        {has("Contacts") && (
          <div className="profileSectionItem Contacts">
            <SectionHeader title={SECTION_TITLES.Contacts} />
            <Contacts UseFormContext={true} />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileSections;
